// The video a workout card shows in its header: the exercise's attached media,
// or the item's own video for VIDEO-type ('V') items. Null when there is none.
const getWorkoutItemVideo = (item) => {
  if (item?.exercise?.media?.[0]) return item.exercise.media[0];
  if (item?.type === 'V' && item?.video?.mediaUrl) return item.video;
  return null;
};

export default getWorkoutItemVideo;
